// Recovered compiled webpack factory 81959. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "ClientPageRoot", {
      enumerable: !0,
      get: function () {
        return a;
      },
    }));
  let n = r(95155);
  function a(e) {
    let { Component: t, searchParams: a, params: o, promises: i } = e;
    {
      let { createRenderSearchParamsFromClient: e } = r(35878),
        i = e(a),
        { createRenderParamsFromClient: s } = r(307),
        l = s(o);
      return (0, n.jsx)(t, { params: l, searchParams: i });
    }
  }
  (r(48302),
    ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
      void 0 === t.default.__esModule &&
      (Object.defineProperty(t.default, "__esModule", { value: !0 }),
      Object.assign(t.default, t),
      (e.exports = t.default)));
}
